export enum ContentType {
    Bookmark = 'bookmark',
    Module = 'module',
    Internal = 'internal'
}
